import React, { useState, useEffect } from "react";
import { data, useOutletContext, Link, useParams } from "react-router-dom";
import { getSaham, postSaham, getTransaksiId } from "../api/services/sahamApi";
import SubmitButton from "../components/buttons/SubmitButton";
import { currencyFormat } from "../components/utils/currencyFormat";
import { formatDate } from "../components/utils/fomatDate";
import Card from "../components/cards/Card";
import TransactionCard from "../components/cards/TransactionCard";


function CariSaham() {
    
    /** Title Header Page */
    const {title, setTitle} = useOutletContext();
    setTitle('Cari Saham');
    
    /** useState */
    const { sahamId } = useParams();
    const [dataSaham, setDataSaham] = useState([]);
    const [sahamSelected, setSahamSelected] = useState();
    const [idSahamSelected, setIdSahamSelected] = useState('');
    const [dataTransaksi, setDataTransaksi] = useState([]);

    useEffect(() => {
        document.title = 'Cari Saham | Sembako';
        getSaham().then(res => setDataSaham(res.data.data))
    },[])

    /** UseEffect if in url store ID */
    useEffect(() => {
        sahamId && selectSaham(sahamId);
        
    },[dataSaham])

    function selectSaham(id) {
        setIdSahamSelected(id);
        dataSaham.map((val, i ) => {
            val.id == id && setSahamSelected(dataSaham[i]);
        })
        getTransaksiId(id).then(res => setDataTransaksi(res.data.data))
    }
    

    function handleSubmit() {

    }

    console.log(dataTransaksi);


    return(
        <>
            <div className="mt-10">
                <label>Pilih Nama Saham</label>
                <select type="text" className="block w-full mt-3 p-3 border-solid border-gray-200 border-3 rounded-2xl" value={idSahamSelected} onChange={(event) => selectSaham(event.target.value)}>
                    <option key="0" selected>Pilih nomer saham</option>
                    {
                        dataSaham.map((val, i) => 
                            val.nama != '' ? (
                                <option key={i} value={val.id} >{val.nomer}. {val.nama} </option>
                            ) : (<></>)
                        )
                    }
                </select>
            </div>
            {sahamSelected ? (
                <div className="grid grid-cols-2 gap-10 mt-10">
                    <div className="rounded-xl bg-gray-50 p-5 pt-10 pb-10">
                        <h3 class="text-x font-semibold">
                            Saham
                        </h3>
                        <span className="mt-3 block">{sahamSelected.jml_saham} Saham s/d Nomer {sahamSelected.no_saham ?? '0'}</span>
                        <span className="mt-3 block">Total : <br/>{currencyFormat(sahamSelected.jml_saham * (sahamSelected.no_saham ?? '0') * 15000)}</span>
                    </div>
                    <div className="rounded-xl bg-gray-50 p-5 pt-10 pb-10">
                        <h3 class="text-x font-semibold">
                            Tabungan
                        </h3>
                        <span className="mt-3 block">{currencyFormat(sahamSelected.tabungan ?? '0')}</span>
                    </div>
                </div>
            ):(<></>) }
            <div className="mt-10">
                
                <Link to={`/cari-saham/${sahamSelected ? sahamSelected.id : ''}/tambah-transaksi`}>
                    <SubmitButton disabled={idSahamSelected == '' ? true : false}>
                        <svg className="inline-block mr-3 icon icon-tabler icons-tabler-outline icon-tabler-plus" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" 
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
                            ><path stroke="none" d="M0 0h24v24H0z" 
                            fill="none"/><path d="M12 5l0 14" /><path d="M5 12l14 0" /></svg>
                            TAMBAH TRANSAKSI
                    </SubmitButton>
                </Link>
            </div>
            <div className="mt-10">
                <div className="flex justify-between items-center">
                    <h3 className="text-xl font-semibold">Transaksi Terakhir</h3>
                </div>
                <div className="mt-7">
                    {
                        dataTransaksi.map((val, i) => 
                                <TransactionCard 
                                    type={val.type_transaksi}
                                    id={val.id}
                                    date={formatDate(val.updated_at)}
                                    jumlahSembako={val.jumlah_sembako}
                                    jmlSaham={val.jml_saham}
                                    nomerSembako={val.nomer_sembako}
                                    jumlahTabungan={val.jumlah_tabungan}
                                />
                        )
                    }
                </div>
            </div>
        </>
    );
}


export default CariSaham;